import type { AdminRoleName } from "../api/types";

/** The four roles, and what each one actually permits.
 *
 * DESCRIPTIONS, NOT A MATRIX. Nothing here is consulted to decide anything: the
 * server resolves what an administrator may do and refuses on its own
 * authority. These sentences exist so an owner granting a role knows what they
 * are handing over, and they are written to match
 * `backend/app/services/authz.py` — if that changes, these are prose that has
 * gone stale, not a control that has broken.
 *
 * The order is by how much authority each carries, most first, because that is
 * the order somebody deciding reads them in.
 */
export const ROLE_ORDER: AdminRoleName[] = [
  "owner",
  "catalog_editor",
  "order_operator",
  "viewer",
];

export const ROLE_LABEL: Record<AdminRoleName, string> = {
  owner: "Owner",
  catalog_editor: "Catalog editor",
  order_operator: "Order operator",
  viewer: "Viewer",
};

export const ROLE_SUMMARY: Record<AdminRoleName, string> = {
  owner:
    "Everything, including the dashboard summary, and managing administrators, their roles and their passwords.",
  catalog_editor:
    "Create and edit products, upload photographs, publish and archive, and use the bulk product workbook. No orders, no stock, no users.",
  order_operator:
    "Read orders and move them through their lifecycle, and adjust stock levels. No catalogue changes.",
  viewer:
    "Read the catalogue and orders. Changes nothing, sees no stock and no dashboard summary.",
};

export function roleLabel(role: AdminRoleName): string {
  return ROLE_LABEL[role] ?? role;
}

/** How a row lists what somebody holds. "None" is a real answer. */
export function rolesLabel(roles: AdminRoleName[]): string {
  if (roles.length === 0) return "No roles";
  return ROLE_ORDER.filter((role) => roles.includes(role))
    .map(roleLabel)
    .join(", ");
}
